export const FREE_CLIENTS = [
  'greenwood',
  'providence',
  'pbh',
  'swedish',
  'summersearch',
  'berkeley',
];

export const MENU_ITEMS = {
  featured: 'featured',
  insights: 'insights',
  news: 'news',
};

export const BIG_LOGO = 'https://assets.crediblemind.com/images/logo.png';
